/**
 * Formatting utilities for display
 */

/**
 * Format date for display (e.g., "March 15, 2024")
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

/**
 * Format date for input (YYYY-MM-DD)
 */
export const formatDateForInput = (date) => {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Format duration in minutes to readable string
 */
export const formatDuration = (minutes) => {
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (mins === 0) {
    return `${hours} hr`;
  }
  return `${hours} hr ${mins} min`;
};

/**
 * Get priority emoji and label
 */
export const getPriorityDisplay = (priority) => {
  const priorities = {
    must_see: { emoji: '🔴', label: 'Must See', color: 'text-red-600' },
    want_to_see: { emoji: '🟡', label: 'Want to See', color: 'text-yellow-600' },
    if_time_allows: { emoji: '🟢', label: 'If Time Allows', color: 'text-green-600' },
  };
  return priorities[priority] || priorities.want_to_see;
};

/**
 * Format place type for display
 */
export const formatPlaceType = (types) => {
  if (!types || types.length === 0) return 'Place';
  
  // Filter out generic types
  const filtered = types.filter(
    type => !['establishment', 'point_of_interest', 'location'].includes(type)
  );
  
  if (filtered.length === 0) return 'Place';
  
  // Convert to readable format
  return filtered[0]
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};



